export default __webpack_public_path__ + "static/media/jz-layer.7a0baa41.png";